import React from 'react';
import IconBase from './Icon-base';
export default class ColorSelectionDropdown extends React.Component {
    render() {
        return (
            <IconBase width="20" height="23" viewBox="0 0 20 23" {...this.props}>
                <g xmlns="http://www.w3.org/2000/svg" id="Canvass" transform="translate(437 228)">
                    <g id="Group 2">
                        <g id="Vector 4s">
                            <use
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                xlinkHref="#path0_strokes"
                                transform="matrix(1 2.67189e-24 -2.67189e-24 1 -434 -227)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rectangle 2s">
                            <use
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                xlinkHref="#path1_fills"
                                transform="translate(-437 -213)"
                                fill={this.props.color}
                            />
                        </g>
                    </g>
                </g>
                <defs xmlns="http://www.w3.org/2000/svg">
                    <path
                        id="path0_strokes"
                        d="M 7 6L 6.6746 6.37963L 7 6.65854L 7.3254 6.37963L 7 6ZM -0.325396 0.379628L 6.6746 6.37963L 7.3254 5.62037L 0.325396 -0.379628L -0.325396 0.379628ZM 7.3254 6.37963L 14.3254 0.379628L 13.6746 -0.379628L 6.6746 5.62037L 7.3254 6.37963Z"
                    />
                    <path
                        id="path1_fills"
                        d="M 0 2C 0 0.895431 0.895431 0 2 0L 18 0C 19.1046 0 20 0.895431 20 2L 20 6C 20 7.10457 19.1046 8 18 8L 2 8C 0.895431 8 0 7.10457 0 6L 0 2Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/ColorSelectionDropdown.js